import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const StarredIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M14.944 6.053a.9.9 0 0 0-.845-.584h-3.657a.3.3 0 0 1-.284-.2L8.845 1.582A.895.895 0 0 0 8.001 1a.91.91 0 0 0-.844.58l-.003.01-1.31 3.68a.3.3 0 0 1-.283.199H1.902a.91.91 0 0 0-.848.588.89.89 0 0 0 .27.991L4.437 9.61a.3.3 0 0 1 .093.323l-1.308 3.89a.89.89 0 0 0 .324 1.005.91.91 0 0 0 1.064-.001l3.212-2.335a.3.3 0 0 1 .355 0l3.211 2.334a.906.906 0 0 0 1.393-.447.9.9 0 0 0-.004-.556L11.47 9.932a.295.295 0 0 1 .093-.324l3.12-2.565a.89.89 0 0 0 .261-.99"
			clipRule="evenodd"
		></path>
	</svg>
))
